// @ts-check
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['PhoneCallType']} PhoneCallType */
/** @typedef {Schemas['PhoneCallTypeCreate']} PhoneCallTypeCreate */
/** @typedef {Schemas['PatchedPhoneCallTypeUpdate']} PhoneCallTypeUpdate */

const BASE = '/api/phone-call-types'

/**
 * GET /api/phone-call-types/
 * @param {{ includeArchived?: boolean }} [params]
 * @returns {Promise<PhoneCallType[]>}
 */
export async function listPhoneCallTypes(params) {
  const { data } = await axios.get(`${BASE}/`, {
    params: params?.includeArchived ? { include_archived: 'true' } : undefined,
  })
  return data
}

/**
 * POST /api/phone-call-types/
 * @param {PhoneCallTypeCreate} body
 * @returns {Promise<PhoneCallType>}
 */
export async function createPhoneCallType(body) {
  const { data } = await axios.post(`${BASE}/`, body)
  return data
}

/**
 * PATCH /api/phone-call-types/{id}/
 * @param {number} id
 * @param {PhoneCallTypeUpdate} body
 * @returns {Promise<PhoneCallType>}
 */
export async function updatePhoneCallType(id, body) {
  const { data } = await axios.patch(`${BASE}/${id}/`, body)
  return data
}

/**
 * POST /api/phone-call-types/{id}/archive/
 * @param {number} id
 * @returns {Promise<{ in_use_count: number }>}
 */
export async function archivePhoneCallType(id) {
  const { data } = await axios.post(`${BASE}/${id}/archive/`)
  return data
}

/**
 * POST /api/phone-call-types/{id}/restore/
 * @param {number} id
 * @returns {Promise<PhoneCallType>}
 */
export async function restorePhoneCallType(id) {
  const { data } = await axios.post(`${BASE}/${id}/restore/`)
  return data
}
